export enum LEAGUE_MODULE_NAMES {
  appointmentScheduling = 'appointment-scheduling',
  assessment = 'assessment',
  benefits = 'benefits',
  careCollections = 'care-collections',
  careDiscovery = 'care-discovery',
  careDocuments = 'care-documents',
  careFinder = 'care-finder',
  careLibrary = 'care-library',
  caregiver = 'caregiver',
  chatHistory = 'chat-history',
  wallet = 'wallet',
  healthJourney = 'health-journey',
  healthJourneyHistory = 'health-journey-history',
  milestones = 'milestones',
  healthNeedPages = 'health-need-pages',
  healthProfile = 'health-profile',
  healthPrograms = 'health-programs',
  healthProgress = 'health-progress',
  messaging = 'messaging',
  onboarding = 'onboarding',
  rewardsAchievements = 'achievements',
  aboutMe = 'about-me',
  claims = 'claims',
  liveChat = 'live-chat',
  home = 'home',
  challenge = 'challenge',
  program = 'program',
  labResults = 'lab-results',
}

export type RoutesMap = {
  [key in LEAGUE_MODULE_NAMES]: string;
};

export const DEFAULT_ROUTES_MAP: RoutesMap = {
  [LEAGUE_MODULE_NAMES.appointmentScheduling]: '/appointment-scheduling',
  [LEAGUE_MODULE_NAMES.assessment]: '/health-profile/questions',
  [LEAGUE_MODULE_NAMES.careCollections]: '/care-collections',
  [LEAGUE_MODULE_NAMES.careDiscovery]: '/get-care',
  [LEAGUE_MODULE_NAMES.careDocuments]: '/documents',
  [LEAGUE_MODULE_NAMES.careFinder]: '/care-finder',
  [LEAGUE_MODULE_NAMES.careLibrary]: '/care-library',
  [LEAGUE_MODULE_NAMES.caregiver]: '/caregiver',
  [LEAGUE_MODULE_NAMES.chatHistory]: '/chat-history',
  [LEAGUE_MODULE_NAMES.benefits]: '/benefits',
  [LEAGUE_MODULE_NAMES.wallet]: '/wallet',
  [LEAGUE_MODULE_NAMES.healthJourney]: '/health-journey',
  [LEAGUE_MODULE_NAMES.healthJourneyHistory]: '/health-history',
  [LEAGUE_MODULE_NAMES.milestones]: '/goals',
  [LEAGUE_MODULE_NAMES.healthNeedPages]: '/health-need',
  [LEAGUE_MODULE_NAMES.healthProfile]: '/health-profile',
  [LEAGUE_MODULE_NAMES.healthPrograms]: '/health-programs',
  [LEAGUE_MODULE_NAMES.healthProgress]: '/health-progress',
  [LEAGUE_MODULE_NAMES.messaging]: '/messaging',
  [LEAGUE_MODULE_NAMES.onboarding]: '/onboarding',
  [LEAGUE_MODULE_NAMES.rewardsAchievements]: '/achievements',
  [LEAGUE_MODULE_NAMES.aboutMe]: '/about-me',
  [LEAGUE_MODULE_NAMES.claims]: '/claims',
  [LEAGUE_MODULE_NAMES.liveChat]: '/live-chat',
  [LEAGUE_MODULE_NAMES.home]: '/home',
  [LEAGUE_MODULE_NAMES.challenge]: '/challenge',
  [LEAGUE_MODULE_NAMES.program]: '/program',
  [LEAGUE_MODULE_NAMES.labResults]: '/lab-results',
};

export const leagueRoutesMap: RoutesMap = {
  ...DEFAULT_ROUTES_MAP,
};
